import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Button, Spinner } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td, } from "react-super-responsive-table"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService"

import IndexBloc from "../Blocs/IndexBlock"
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"

class TableSecondComponent extends Component {
    indexBloc = new IndexBloc()

    source
    constructor(props) {
        super(props)
        this.state = {
            loadingTable: false,
            cancelDate: null,
            rows: [],
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadData = async () => {
        this.setState({loadingTable: true})
        var additionalFilter = this.props.additionalFilter
        this.indexBloc.fetchListRekapAbsensi({...additionalFilter});
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.cancelDate()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.indexBloc.listRekapAbsesnsiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false,
                        rows: []
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.listRekapAbsesnsiChannel?.unsubscribe()
    }

    render() {
        return (
            <>
                <div className="table-responsive">
                    <Table
                        className="table table-striped table-bordered table-hover"
                    >
                        <thead className="table-primary">
                            <tr>
                                <th className="text-center" width="*" rowSpan="3">No</th>
                                <th className="text-left" width="*" rowSpan="3">NIP</th>
                                <th className="text-center" width="*" rowSpan="3">Nama</th>
                                <th className="text-center" width="*" colSpan="6">Sekarang</th>
                            </tr>
                            <tr>
                                <th className="text-center" width="*" rowSpan="2">Pangkat/Golongan</th>
                                <th className="text-center" width="*">Jumlah Kehadiran</th>
                                <th className="text-center" width="*" colSpan="4">Jumlah Ketidakhadiran</th>
                            </tr>
                            <tr>
                                <th className="text-center" width="*">Hadir</th>
                                <th className="text-center" width="*">Alpha</th>
                                <th className="text-center" width="*">Cuti</th>
                                <th className="text-center" width="*">Dinas</th>
                                <th className="text-center" width="*">Tugas Belajar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.loadingTable == false ?
                                    this.state.rows.length > 0 ? 

                                        this.state.rows.map((data, index) => {
                                            return (
                                                <tr>
                                                    <td>{index+=1}</td>
                                                    <td>{data.presensi_summary_employee_nip}</td>
                                                    <td>{data.employee_full_name}</td>

                                                    <td>{data.presensi_summary_emp_rank_group_room}</td>
                                                    <td>{data.presensi_summary_total_hadir}</td>
                                                    <td>{data.presensi_summary_total_alpha}</td>
                                                    <td>{data.presensi_summary_total_cuti}</td>
                                                    <td>{data.presensi_summary_total_dinas}</td>
                                                    <td>{data.presensi_summary_total_tugas_belajar}</td>
                                                </tr>
                                            );
                                        })

                                    : 
                                    <tr>
                                        <td colSpan="9" className="text-center">Tidak Ada Data</td>
                                    </tr>
                                :
                                <tr>
                                    <td colSpan="9" className="text-center"><Spinner className="m-2" color="primary" /></td>
                                </tr>
                            }
                        </tbody>
                    </Table>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan membatalkan data presensi ini?"

                    loadingTitle="Mengambil data"
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                </div>
            </>
        )
    }

}

export default TableSecondComponent